<template>
  <div class="papers-assigned-detail wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">学生信息</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">学校</div></th>
              <th><div class="kh-table-cell">学号</div></th>
              <th><div class="kh-table-cell">姓名</div></th>
              <th><div class="kh-table-cell">一级学科</div></th>
              <th><div class="kh-table-cell">二级学科</div></th>
              <th><div class="kh-table-cell">论文涉及研究方向</div></th>
              <th><div class="kh-table-cell">论文题目</div></th>
              <th><div class="kh-table-cell">送审专家数</div></th>
              <th><div class="kh-table-cell">单位提交时间</div></th>
              <th><div class="kh-table-cell">送审专家数操作</div></th>
            </tr>
            </thead>
            <!-- <tbody>
            <tr class="kh-table-row">
              <td><div class="kh-table-cell">{{studentMsg.unitName}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.schoolNo}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.authorName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.firstSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.secondSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.researchAera}}</div></td>
              <td><div class="kh-table-cell">{{studentMsg.titleCn}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.sendNum + '/' + studentMsg.auditExpertNum}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">{{studentMsg.submitTime}}</div></td>
              <td v-if="from!=='unit'"><div class="kh-table-cell">
                <span class="link-a" @click="showUpdateExpertNum">修改</span>
              </div></td>
            </tr>
            </tbody> -->
          </table>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">已送单位</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">单位名称</div></th>
              <th><div class="kh-table-cell">联系人</div></th>
              <th><div class="kh-table-cell">联系电话</div></th>
              <th><div class="kh-table-cell">联系地址</div></th>
              <th><div class="kh-table-cell">操作</div></th>
            </tr>
            </thead>
            <tbody>
            <!-- <tr class="kh-table-row" v-if="receiveUnitList[0].id"> -->
            <tr class="kh-table-row" v-for="(item,index) in this.receiveUnitList" :key="index">
              <td><div class="kh-table-cell">{{item.unitName}}</div></td>
              <td><div class="kh-table-cell">{{item.contactName}}</div></td>
              <td><div class="kh-table-cell">{{item.contactTel}}</div></td>
              <td><div class="kh-table-cell">{{item.idCardType}}</div></td>
              <td><div class="kh-table-cell">
                <span v-if="studentMsg.reviewStatus!=='2'" class="link-a" @click="requestCancelSend(item)">撤销</span>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">已送专家</label>
        <div class="kh-table kh-table-default kh-table-border">
          <table cellspacing="0">
            <thead>
            <tr>
              <th><div class="kh-table-cell">姓名</div></th>
              <th><div class="kh-table-cell">导师类型</div></th>
              <th><div class="kh-table-cell">技术职务</div></th>
              <th><div class="kh-table-cell">单位</div></th>
              <th><div class="kh-table-cell">一级学科</div></th>
              <th><div class="kh-table-cell">二级学科</div></th>
              <th><div class="kh-table-cell">专业学位</div></th>
              <th><div class="kh-table-cell">专业领域</div></th>
              <th><div class="kh-table-cell">联系电话</div></th>
              <th><div class="kh-table-cell">邮箱</div></th>
              <th><div class="kh-table-cell">操作</div></th>
            </tr>
            </thead>
            <!-- <tbody>
            <tr class="kh-table-row" v-for="(expert,index) in acceptExpertList" :key="expert.id+'-number'+index">
              <td><div class="kh-table-cell"><span class="link-span" @click="displayExpertMessage(expert)">{{expert.name}}</span></div></td>
              <td><div class="kh-table-cell">{{typeMap[expert.acTutorType]}}</div></td>
              <td><div class="kh-table-cell">{{positionMap[Number(expert.techPosition)]}}</div></td>
              <td><div class="kh-table-cell">{{expert.orgName}}</div></td>
              <td><div class="kh-table-cell">{{expert.mFirstSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{expert.mSecondSubjectName}}</div></td>
              <td><div class="kh-table-cell">{{expert.degreeCategoryName}}</div></td>
              <td><div class="kh-table-cell">{{expert.degreeDomainName}}</div></td>
              <td><div class="kh-table-cell">{{expert.phone}}</div></td>
              <td><div class="kh-table-cell">{{expert.email1}}</div></td>
              <td><div class="kh-table-cell">
                <span v-if="(expert.reviewStatus!=='2')" class="link-a" @click="requestCancelSend(expert)">撤销</span>
                <span v-if="expert.reviewStatus==='2' && from!=='unit'" class="link-a" @click="resetReviewStatus(expert)">重置评阅</span>
              </div></td>
            </tr>
            </tbody> -->
          </table>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">指派记录</label>
        <div class="">
          <regular-page
            ref="sendExpertPage"
            config-path="/enrolment/regular/thesisManage/assignedRecord"
          ></regular-page>
        </div>
      </div>
      <div class="wrap-form">
        <label class="form-label">下载附件</label>
        <div style="display:flex">
          <p>
            <span>论文原文下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(paperFileId)"/>
          </p>
          <p style="margin-left:30px">
            <span>摘要下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(absFileId)"/>
          </p>
          <p style="margin-left:30px">
            <span>简况表下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(biFileId)"/>
          </p>
          <p style="margin-left:30px">
            <span>自评表下载：</span>
            <Icon type="ios-cloud-download-outline" class="text-down" @click="handleDown(srFileId)"/>
          </p>
        </div>
      </div>
      <div class="g-ta-c">
        <Button type="default" @click="back" class="save">返回</Button>
      </div>
    </div>
  </div>
</template>
<script>
import regularPage from '../../regularPage'
export default {
  name: 'papersAssignedDetail',
  components: {regularPage},
  props: {
    query: ''
  },
  data () {
    return {
      from: '',
      currentId: '',
      paperId: '',
      studentMsg: {},
      loading: true,
      paperFileId: '',
      absFileId: '',
      biFileId: '',
      srFileId: '',
      expDTOList: [],
      receiveUnitList: [],
      expReviewFlowDTOList: []

    }
  },
  created () {
    this.currentId = this.query.split('&')[0].split('id=')[1] || this.$route.query.id;
    this.paperId = this.query.split('&')[2].split('paperid=')[1] || this.$route.query.paperid;
    this.from = this.query.split('from=')[1] || this.$route.query.from;
    this.fetchDefaultMessage();
  },
  methods: {
    fetchDefaultMessage () {
      const _self = this;
      _self.loading = true;
      let url = '/custom/sendPaper/getPaperDetail/';
      console.log(url + _self.paperId)
      _self.post(url + _self.paperId).then(res => {
        this.expDTOList = res.data.expDTOList
        this.receiveUnitList = res.data.receiveUnitList
        this.expReviewFlowDTOList = res.data.expReviewFlowDTOList
        console.log(res)
      }).catch(() => {
        _self.loading = false;
      });
    },
    back () {
      this.$emit('back');
    },
    handleDown (value) {
      this.fetch(`/paper/fileInfo/downloadFile/` + value).then(res => {
        if (res.code === 200) {
          setTimeout(function () {
            window.open(res.data);
          }, 1);
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.text-down {
  font-size: 25px;
  color: #1890FF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/papersAssignedDetail.vue